import { useEffect, useState } from 'react';
import { api } from '../api';

/**
 * Whether the active project has at least one approved area budget.
 * Used to hide executive dashboards until real financial data exists.
 */
export function useProjectHasApprovedBudget(projectId) {
    const [hasApproved, setHasApproved] = useState(null);

    useEffect(() => {
        if (!projectId) {
            setHasApproved(false);
            return undefined;
        }

        let cancelled = false;
        (async () => {
            try {
                const { data } = await api.get(`/projects/${projectId}/budgets`);
                const approved = (data || []).some(
                    (b) => b.is_approved === true || b.status === 'approved'
                );
                if (!cancelled) setHasApproved(approved);
            } catch {
                if (!cancelled) setHasApproved(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, [projectId]);

    return hasApproved;
}
